import { render, staticRenderFns } from "./createCategorie.vue?vue&type=template&id=601e8e55"
import script from "./createCategorie.vue?vue&type=script&lang=ts"
export * from "./createCategorie.vue?vue&type=script&lang=ts"
import style0 from "./createCategorie.vue?vue&type=style&index=0&id=601e8e55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports